import { __setFunctionName } from "tslib";
import * as angular from 'angular';
import './layouts/TermsLayout.scss';
import AnonLayout from './layouts/AnonLayout.html';
import AuthLayout from './layouts/auth/AuthLayout.html';
import { AuthLayoutController } from 'layouts/auth/AuthLayoutController';
import TermsLayout from './layouts/TermsLayout.html';
import { SentryClient } from 'monitoring-error-handler';
import ActivateController from './modules/account/activate/ActivateController';
import ActivateView from './modules/account/activate/ActivateView.html';
export default angular
    .module('app.states', ['ui.router'])
    .config(['$stateProvider', '$urlRouterProvider', '$locationProvider', function ($stateProvider, $urlRouterProvider, $locationProvider) {
        var _a, _b;
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false,
        });
        $urlRouterProvider.otherwise('/application');
        $stateProvider
            .state('anon', {
            abstract: true,
            template: AnonLayout,
            controller: (_a = class {
                    constructor($state, $scope, LoadingService) {
                        this.$state = $state;
                        $scope.isLoadingGlobal = LoadingService.isLoadingGlobal;
                        $scope.isLoadingLocal = LoadingService.isLoadingLocal;
                    }
                    get areaClass() {
                        return `area-${this.$state.params.area}`;
                    }
                },
                __setFunctionName(_a, "controller"),
                _a.$inject = ['$state', '$scope', 'LoadingService'],
                _a),
            controllerAs: '$ctrl',
            resolve: {
                translateReady,
            },
        })
            .state('terms', {
            url: '/terms',
            controller: (_b = class {
                    constructor(TranslateService) {
                        this.TranslateService = TranslateService;
                    }
                    changeCurrentLanguage(language) {
                        this.TranslateService.setCurrentLanguage(language);
                    }
                },
                __setFunctionName(_b, "controller"),
                _b.$inject = ['TranslateService'],
                _b),
            controllerAs: '$ctrl',
            template: TermsLayout,
            data: { restricted: 'noRedirect' },
            resolve: {
                translateReady,
            },
        })
            .state('activate', {
            url: '/activate/:email?token',
            controller: ActivateController,
            controllerAs: '$ctrl',
            template: ActivateView,
            params: {
                email: undefined,
                token: undefined,
            },
            data: { restricted: 'noRedirect' },
            resolve: {
                translateReady,
            },
        })
            .state('auth', {
            abstract: true,
            template: AuthLayout,
            data: { restricted: true },
            controller: AuthLayoutController,
            controllerAs: '$ctrl',
            resolve: {
                translateReady,
                isUserInitialized: ['AccountService2', 'InitializeUserService', async function (AccountService2, InitializeUserService) {
                        const me = await AccountService2.me();
                        await InitializeUserService.initFeatureToggle();
                        // Identify user to track errors
                        SentryClient.identifyUser({ email: me.email, id: me.identity.toString() });
                    }],
            },
        })
            .state('redirect-success', {
            url: '/redirect-success',
            controller: class {
                constructor() {
                    this.onLoad();
                }
                onLoad() {
                    window.close();
                }
            },
            controllerAs: '$ctrl',
            template: '',
            resolve: {
                translateReady,
            },
        });
    }]).name;
const translateReady = ['$translate', function ($translate) { return $translate.onReady(); }];
